import React, { PureComponent } from 'react'
import { Col, Container, Row } from 'reactstrap'
import ProfileTabs from './components/ProfileTabs'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class Calendar extends PureComponent {
  componentWillMount () {
    return this.props.user ? null : this.props.history.push('/unauthorized')
  }

  render () {
    return (
      <Container>
        <div className='profile'>
          <Row>
            <Col md={12}>
              <h3 className='page-title'>Settings</h3>
              <h3 className='page-subhead subhead'>
                Change your General Settings by updating your personal password, company details and packages
              </h3>
            </Col>
          </Row>
          {/* <Row>
            <Col md={6} lg={6} xl={6}>
              <ProfileMain />
            </Col>
            <Col md={6} lg={6} xl={6}>
              <ProfileTasks />
    </Col>
          </Row> */}
          <Row>
            <Col md={12} lg={12} xl={12}>
              <ProfileTabs user={this.props.user} />
            </Col>
          </Row>
        </div>
      </Container >
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps)(withRouter(Calendar))



// WEBPACK FOOTER //
// ./src/components/account/profile/Profile.js